import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "role-selector" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Role = _resolveComponent("Role")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.ROLES, (role) => {
      return (_openBlock(), _createBlock(_component_Role, {
        key: role.type,
        type: role.type,
        class: _normalizeClass({ 'is-active': $options.isSelected(role.type) }),
        onClick: $event => ($options.toggleRole(role.type))
      }, null, 8 /* PROPS */, ["type", "class", "onClick"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}